import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SortListService {

  source: any;
  sourceId: number;
  destinationId: number;
  event: EventTarget;

  constructor() {
  }

  /**
   * Check if one element is before the other.
   * @param a
   * @param b
   * @returns {boolean}
   */
  isbefore(a, b) {
    if (a.parentNode === b.parentNode) {
      for (let cur = a; cur; cur = cur.previousSibling) {
        if (cur === b) {
          return true;
        }
      }
    }
    return false;
  }

  /**
   * On drag end we return the new order array using the source id and the destination id saved in dragEnter
   * @param $event
   */
  dragEnd<T>(array: number[]): number[] {
    const indexSource = array.lastIndexOf(this.sourceId);
    array.splice(indexSource, 1);
    const indexDragEnd = array.lastIndexOf(this.destinationId);
    array.splice(indexDragEnd, 0, this.sourceId);
    return array;
  }


  /**
   * On drag enter we update the html view (we should do this in drag enter bc in drag end we don't have the destination
   * only the source target.
   * And we save the last destination id where the point enter.
   * @param $event
   * @param destinationId
   */
  dragEnter($event, destinationId: number) {
    const target = $event.currentTarget;
    if (this.isbefore(this.source, target)) {
      target.parentNode.insertBefore(this.source, target); // insert before
    } else {
      target.parentNode.insertBefore(this.source, target.nextSibling); // insert after
    }
    this.destinationId = (destinationId !== this.sourceId ) ? destinationId : this.destinationId;
  }

  /**
   * On drag start we save the source event Target and the source id.
   */
  dragStart($event: DragEvent, sourceId: number) {
    this.source = $event.currentTarget;
    this.sourceId = sourceId;
    $event.dataTransfer.effectAllowed = 'move';
  }

}
